import { useState } from "react";

const useAlertModal = () => {
  const [modalConfig, setModalConfig] = useState({
    show: false,
    title: "Confirmation",
    message: "Are you sure?",
    type: "confirm",
    confirmText: "Confirm",
    cancelText: "Cancel",
    onConfirm: () => {},
    onCancel: () => {},
    size: "md",
    centered: true,
    showCancelButton: true,
    confirmVariant: "primary",
    cancelVariant: "secondary",
    icon: null,
    children: null,
  });

  const showAlert = (config) => {
    setModalConfig({
      ...modalConfig,
      ...config,
      show: true,
    });
  };

  const hideAlert = () => {
    setModalConfig({
      ...modalConfig,
      show: false,
    });
  };

  // Predefined alert types for common use cases
  const showConfirm = (message, onConfirm, title = "Confirm Action") => {
    showAlert({
      title,
      message,
      type: "confirm",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm,
      confirmVariant: "primary",
    });
  };

  const showSuccess = (message, onConfirm, title = "Success") => {
    showAlert({
      title,
      message,
      type: "success",
      confirmText: "OK",
      showCancelButton: false,
      onConfirm,
      confirmVariant: "success",
    });
  };

  const showError = (message, onConfirm, title = "Error") => {
    showAlert({
      title,
      message,
      type: "error",
      confirmText: "OK",
      showCancelButton: false,
      onConfirm,
      confirmVariant: "danger",
    });
  };

  const showWarning = (message, onConfirm, title = "Warning") => {
    showAlert({
      title,
      message,
      type: "warning",
      confirmText: "OK",
      showCancelButton: false,
      onConfirm,
      confirmVariant: "warning",
    });
  };

  const showInfo = (message, onConfirm, title = "Information") => {
    showAlert({
      title,
      message,
      type: "info",
      confirmText: "OK",
      showCancelButton: false,
      onConfirm,
      confirmVariant: "info",
    });
  };

  const showDelete = (itemName, onConfirm, title = "Delete Confirmation") => {
    showAlert({
      title,
      message: `Are you sure you want to delete ${itemName}? This action cannot be undone.`,
      type: "danger",
      confirmText: "Delete",
      cancelText: "Cancel",
      onConfirm,
      confirmVariant: "danger",
    });
  };

  return {
    modalConfig,
    showAlert,
    hideAlert,
    showConfirm,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showDelete,
  };
};

export default useAlertModal;